export default "__VITE_ASSET__8fKUfb5s__"